// Libraries
import { HttpParams } from '@angular/common/http';
import * as lodash from 'lodash';

/**
 * Provides a set of methods used for http.
 */
export class HttpUtils {

  /**
   * Append data to http params
   * @param params Http params
   * @param data Data to append
   * @param arraySep Array separator
   * @return New http params
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   */
  public static appendParams(params: HttpParams, data: any, arraySep: string = ''): HttpParams {
    lodash.forOwn(data, (value: any, key: any) => {
      // Check if is an array or not
      if (lodash.isArray(value)) {
        if (value.length > 0) {
          params = params.set(key, value.join(arraySep));
        }
      } else {
        params = params.set(key, value);
      }
    });
    return params;
  }
}
